import { extractAddressComponents } from './address';

// Reverse-geocode { lat, lng } or false
export default function geocodeByLatLng(latLng) {
    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve) => {
        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status !== 'OK') {
                console.warn(`geocodeByLatLng failed: ${status}`);
                resolve(false);
                return;
            }

            const components = results[0].address_components;
            const extracted = extractAddressComponents(components);

            // No street autofill
            if (!extracted.hasStreetNumber || !extracted.hasRoute) {
                resolve(false);
                return;
            }

            const toReturn = {};
            if (extracted.street) toReturn.street = extracted.street;
            if (extracted.city) toReturn.city = extracted.city;
            if (extracted.state) toReturn.state = extracted.state;
            if (extracted.zip) toReturn.zip = extracted.zip;

            if (results[0].formatted_address) {
                toReturn.fulladdress = results[0].formatted_address;
                toReturn.address = results[0].formatted_address;
            }

            resolve(toReturn);
        });
    });
}
